import React from "react"
import {
  Descripition,
  Headline,
  StyledGradientTitle,
  animationProperties,
} from "../../../utils"
import { MapCard } from "../../atoms"
import { AosWrapper } from "../../molecules/AosWrapper"
import useDeviceTheme from "@project/shared/src/useDeviceTheme"
import { MapCardWrapper, Wrapper } from "./style"

const LocationSection: React.FC = () => {
  const isDarkTheme = useDeviceTheme()
  return (
    <Wrapper id={"contact"}>
      <AosWrapper
        className={"map-background"}
        animateIn={"animate__fadeInUpBig animate__zoomIn"}
      >
        <img
          src={
            isDarkTheme
              ? "/assets/imgs/contact.svg"
              : "/assets/imgs/contact-light.svg"
          }
          width={"100%"}
          height={"auto"}
          style={{ objectFit: "contain" }}
          className={"map-background"}
        />
      </AosWrapper>
      <AosWrapper
        duration={animationProperties.duration + 0.2}
        delay={animationProperties.delay + 0.2}
      >
        <Headline>
          {"We’re here to"}
          <StyledGradientTitle> {"hear "}</StyledGradientTitle>
          {"from you"}
        </Headline>
        <Descripition>
          {
            "We are Japan based company with developers team from all around Nepal and Management team \n from Japan collaborating at our best to come-up with the innovative approach to serve technology."
          }
        </Descripition>
        <MapCardWrapper>
          <AosWrapper
            duration={animationProperties.duration + 1}
            delay={animationProperties.delay + 1}
            animateIn={"animate__fadeInUpBig animate__zoomIn"}
          >
            <MapCard
              country={"Nepal"}
              officeType={"Branch Office"}
              description={
                "We are here in Nepal to hear from you. Feel free to contact us in the details below in case of any inquiry."
              }
              location={"Satdobato-15, Laitpur"}
              email={"hr@readytowork.work"}
            />
          </AosWrapper>
          <AosWrapper
            duration={animationProperties.duration + 1}
            delay={animationProperties.delay + 1}
            animateIn={"animate__fadeInUpBig animate__zoomIn"}
          >
            <MapCard
              country={"Japan"}
              description={
                "Our head office is located at Japan responsible for\n suppervising and managing the workflow of the\n company."
              }
              officeType={"Head Office"}
              location={"〒152ｰ0004"}
              location2={"東京都目黒区鷹番1-1-5 4F C-15"}
              email={"admin@readytowork.work"}
            />
          </AosWrapper>
        </MapCardWrapper>
      </AosWrapper>
    </Wrapper>
  )
}

export { LocationSection }
